<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
    class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{
          Object.entries(this.data).length > 2 ? "UPDATE" : "ADD NEW"
        }}
        PRODUCT
      </h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <div class="vx-row w-full">
          <div class="vx-col w-full" style="font-size: 90%">
            <vs-input label="Product" v-model="dataProduct" class="mt-4 w-full" name="quantity" />
          </div>
        </div>
        <div class="vx-row w-full">
          <div class="vx-col w-full" style="font-size: 90%">
            <vs-input label="Account" v-model="dataAccount" class="mt-4 w-full" name="account" 
                v-validate="'integer'" />
              <span class="text-danger text-sm" v-show="errors.has('account')">{{
                errors.first("account")
              }}</span> 
          </div>
        </div>

        <br v-if="Object.entries(this.data).length <= 2" />
        <hr v-if="Object.entries(this.data).length <= 2" class="mt-5 w-full" />
        <div class="vx-row w-full">
          <div class="vx-col w-1/2">
            <vs-input label="Quantity" v-model="dataQuantity" class="mt-4 w-full" name="quantity"  v-validate="'decimal'"
              @input="updateTotalPrices()" />
              <span class="text-danger text-sm" v-show="errors.has('quantity')">{{
                errors.first("quantity")
              }}</span> 
          </div>
          <div class="vx-col w-1/2">
            <vs-input label="Unit of Measure" v-model="dataUom" class="mt-4 w-full" name="uom" />
          </div>
        </div>
        <hr class="mt-5 w-full" />
        <div class="vx-row w-full">
          <div class="vs-con-loading__container vx-col w-1/2">
            <vs-input :label="'Currency'" v-model="dataCurrency" class="mt-4 w-full" name="Currency" />
          </div>
          <div class="vs-con-loading__container vx-col w-1/2">
            <vs-input :label="'VAT (%)'" v-model="dataTva" class="mt-4 w-full" name="VAT" v-validate="'decimal'"/>
              <span class="text-danger text-sm" v-show="errors.has('VAT')">{{
                errors.first("VAT")
              }}</span> 
          </div>
        </div>
        <hr class="mt-5 w-full" />
        <div class="vx-row w-full">
          <div id="div-with-loading-eur" class="vs-con-loading__container vx-col w-1/2">
            <vs-input :label="'Unit Excl. Tax (' + dataCurrency + '/' + dataUom + ')'" v-model="dataUnitPrice" v-validate="'decimal|required'"
              @focus="handleUnitPriceFocus" @blur="handleUnitPriceBlur" class="mt-4 w-full" name="exunitprice" />
              <span class="text-danger text-sm" v-show="errors.has('exunitprice')">{{
                errors.first("exunitprice")
              }}</span> 
          </div>

          <div class="vx-col w-1/2">
            <vs-input :label="'Total Excl. Tax (' + dataCurrency + ')'" v-model="dataTotalPrice" v-validate="'decimal|required'"
              @focus="handleTotalPriceFocus" @blur="handleTotalPriceBlur" class="mt-4 w-full" name="exprice" />
              <span class="text-danger text-sm" v-show="errors.has('exprice')">{{
                errors.first("exprice")
              }}</span> 
          </div>
        </div>
        <div class="vx-row w-full">
          <div id="div-with-loading-eur" class="vs-con-loading__container vx-col w-1/2">
            <vs-input :label="'Unit Incl. Tax (' + dataCurrency + '/' + dataUom + ')'" v-model="dataUnitPriceVAT" v-validate="'decimal|required'"
              @focus="handleUnitPriceVATFocus" @blur="handleUnitPriceVATBlur" class="mt-4 w-full" name="unitprice" />
              <span class="text-danger text-sm" v-show="errors.has('unitprice')">{{
                errors.first("unitprice")
              }}</span> 
          </div>

          <div class="vx-col w-1/2">
            <vs-input :label="'Total Incl. Tax (' + dataCurrency + ')'" v-model="dataTotalPriceVAT"
              @focus="handleTotalPriceVATFocus" @blur="handleTotalPriceVATBlur" v-validate="'decimal|required'"
              class="mt-4 w-full" name="price" />
              <span class="text-danger text-sm" v-show="errors.has('price')">{{
                errors.first("price")
              }}</span> 
          </div>
        </div>
      </div>

    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>
 
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from "@/axios.js";
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import vSelect from "vue-select";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => { },
    },
  },
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      isUnitPriceFocused: false,
      isTotalPriceFocused: false,
      isUnitPriceVATFocused: false,
      isTotalPriceVATFocused: false,

      dataAccount: null,
      dataUnitPrice: 0,
      dataTotalPrice: 0,
      dataUnitPriceVAT: 0,
      dataTotalPriceVAT: 0,
      isUpdating: false,

      dataQuantity: 1, // Default quantity

      dataTva: 19, // Default VAT rate
      dataId: null,
      dataCurrency: null,
      dataProduct: "",
      dataUom: "",
      dataIdCategoryOperation: null,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  watch: {
    dataUnitPrice(newVal) {
      this.calculateTotalPrice();
    },
    dataQuantity(newVal) {
      this.calculateTotalPrice();
    },
    dataTotalPrice(newVal) {
      this.calculateUnitPrice();
    },
    dataUnitPriceVAT(newVal) {
      this.calculateTotalPriceVAT();
    },
    dataTotalPriceVAT(newVal) {
      this.calculateUnitPriceVAT();
    },
    dataTva(newVal) {
      this.calculateVatPrices();
    },
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 2) {
        this.initValues();
        this.$validator.reset();
        this.dataIdOperation = this.data.idoperation;
        this.dataIdCategoryOperation = this.data.idcategoryoperation;
      } else {
        console.log(this.data)
        
        this.dataAccount = this.data.cont;
        this.dataProduct = this.data.product;
        this.dataIdOperation = this.data.idoperation;
        this.dataCurrency = this.data.currency;
        this.dataTva = this.data.tva_pct;
        this.dataIdCategoryOperation = this.data.idcategoryoperation;
        this.dataQuantity = this.data.quantity;
        this.dataUom = this.data.uom;

        if (this.data.unit_price_htva) {
          this.dataUnitPrice = Math.abs(
            this.data.unit_price_htva
          );
          // SALE
          this.dataTotalPrice =
            Math.abs(this.data.unit_price_htva) *
            Math.abs(this.dataQuantity);
        }
        this.initValues();
      }
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
    isFormValid() {
      return (
        (!this.errors.any() && this.dataProduct && this.dataQuantity) ||
        (this.data.id && this.dataQuantity && this.dataProduct)
      );
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    handleTotalPriceVATFocus() {
      this.isTotalPriceVATFocused = true;
    },
    handleTotalPriceVATBlur() {
      this.isTotalPriceVATFocused = false;
    },

    handleTotalPriceFocus() {
      this.isTotalPriceFocused = true;
    },
    handleTotalPriceBlur() {
      this.isTotalPriceFocused = false;
    },

    handleUnitPriceVATFocus() {
      this.isUnitPriceVATFocused = true;
    },
    handleUnitPriceVATBlur() {
      this.isUnitPriceVATFocused = false;
    },

    handleUnitPriceFocus() {
      this.isUnitPriceFocused = true;
    },
    handleUnitPriceBlur() {
      this.isUnitPriceFocused = false;
    },
    calculateTotalPriceVAT() {
      let unitPriceVAT = parseFloat(this.dataUnitPriceVAT) || 0;
      let quantity = parseFloat(this.dataQuantity) || 0;
      if (!this.isTotalPriceVATFocused) this.dataTotalPriceVAT = (unitPriceVAT * quantity).toFixed(4);
    },

    calculateTotalPrice() {
      let unitPrice = parseFloat(this.dataUnitPrice) || 0;
      let quantity = parseFloat(this.dataQuantity) || 0;

      if (!this.isTotalPriceFocused) this.dataTotalPrice = (unitPrice * quantity).toFixed(4);
      if (!this.isTotalPriceVATFocused) this.dataTotalPriceVAT = (unitPrice * quantity * (1 + this.dataTva / 100)).toFixed(4);
    },

    calculateUnitPrice() {
      let totalPrice = parseFloat(this.dataTotalPrice) || 0;
      let quantity = parseFloat(this.dataQuantity) || 0;

      if (quantity > 0 && !this.isUnitPriceFocused) {
        this.dataUnitPrice = (totalPrice / quantity).toFixed(8);
      }
    },

    calculateUnitPriceVAT() {
      let totalPriceVAT = parseFloat(this.dataTotalPriceVAT) || 0;
      let quantity = parseFloat(this.dataQuantity) || 0;

      if (quantity > 0) {
        let unitPriceVAT = (totalPriceVAT / quantity).toFixed(8);
        if (!this.isUnitPriceVATFocused) this.dataUnitPriceVAT = unitPriceVAT;
        if (!this.isUnitPriceFocused) this.dataUnitPrice = (parseFloat(unitPriceVAT) / (1 + this.dataTva / 100)).toFixed(8);
      }
    },

    calculateVatPrices() {
      let unitPrice = parseFloat(this.dataUnitPrice) || 0;
      let quantity = parseFloat(this.dataQuantity) || 0;

      if (!this.isUnitPriceVATFocused) this.dataUnitPriceVAT = (unitPrice * (1 + this.dataTva / 100)).toFixed(4);
      if (!this.isTotalPriceVATFocused) this.dataTotalPriceVAT = (unitPrice * quantity * (1 + this.dataTva / 100)).toFixed(4);
    },


    initValues() {
      if (this.data.id) return;
      (this.dataProductCategoryId = ""),
        (this.dataProduct = ""),
        (this.dataQuantity = ""),
        (this.dataUom = ""),
        (this.dataUnitPrice = ""),
        (this.dataTva = ""),
        (this.dataCurrency = ""),
        (this.dataAccount = ""),
        (this.dataTotalPrice = "");
    },
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var obj = {};

          obj = {
            idoperation: this.data.idoperation,
            id: this.data.id,
            product: this.dataProduct,
            quantity: this.dataQuantity,
            uom: this.dataUom,
            currency: this.dataCurrency,
            unit_price_htva: this.dataUnitPrice,
            cont:this.dataAccount,
            tva_pct: this.dataTva,
          };


          if (this.data.id !== null && this.data.id >= 0) {
            this.$store
              .dispatch("operationList/updateExpenseProduct", obj)
              .then((res) => {
                this.$vs.notify({
                  color: "success",
                  title: "Product Updated!",
                  text: "The product was successfully updated",
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "An issue occured, please contact your dev!",
                  text: "The product was NOT updated",
                });
              });
          } else {
            delete obj.id;
            this.$store
              .dispatch("operationList/createExpenseProduct", obj)
              .then((res) => {
                this.$vs.notify({
                  color: "success",
                  title: "Product Created!",
                  text: "The product was successfully added",
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "An issue occured, please contact your dev!",
                  text: "The product was NOT added",
                });
              });
          }
        }
      });
    },
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
